interface MatchFiltersProps {
  value: string;
  onChange: (value: string) => void;
  counts?: Record<string, number>;
}

const TABS = [
  { key: 'all', label: 'All' },
  { key: 'live', label: 'Live' },
  { key: 'upcoming', label: 'Upcoming' },
  { key: 'finished', label: 'Finished' },
];

export function MatchFilters({ value, onChange, counts }: MatchFiltersProps) {
  return (
    <div className="flex gap-1 bg-bg-elevated rounded-lg p-1 border border-border w-fit">
      {TABS.map((tab) => (
        <button
          key={tab.key}
          onClick={() => onChange(tab.key)}
          className={`px-3 py-1.5 rounded-md text-xs font-medium transition-colors ${
            value === tab.key
              ? 'bg-accent text-white'
              : 'text-text-muted hover:text-text hover:bg-bg-hover'
          }`}
        >
          {tab.label}
          {counts?.[tab.key] !== undefined && (
            <span className="ml-1.5 text-[10px] opacity-70 tabular-nums">
              {counts[tab.key]}
            </span>
          )}
        </button>
      ))}
    </div>
  );
}
